import * as Yup from 'yup'

export const saveRuleSchema = Yup.object().shape({
  name: Yup.string(),
  products: Yup.array().min(1),
  offers: Yup.array().min(1),
})

export const ruleSchema = ['name', 'products', 'offers']
